import "./SiteHeader.css";
import BurgerMenu from "./BurgerMenu";

// Header partagé entre la page publique et la partie gestion :
// retour puis marque (et titre de page éventuel) à gauche, actions
// contextuelles à droite (children).
function SiteHeader({ position = "sticky", onLogoClick, onBack, title, children }) {
  return (
    <header className={`site-header site-header-${position}`}>
      <div className="site-header-inner">
        {onBack && (
          <button className="rc-btn rc-btn-outline site-header-btn site-header-back" onClick={onBack}>
            Retour
          </button>
        )}
        <div className="site-header-brand">
          {onLogoClick ? (
            <button className="rc-wordmark site-header-logo" onClick={onLogoClick}>
              Racines
            </button>
          ) : (
            <span className="rc-wordmark site-header-logo">Racines</span>
          )}
          <span className="site-header-tagline">
            Cartes de fidélité · Commerces de proximité
          </span>
        </div>
        {title && <h1 className="site-header-title">{title}</h1>}
        <div className="site-header-actions">{children}</div>
      </div>
    </header>
  );
}

// Actions de compte communes aux pages publiques (landing, offres, commande) :
// connecté → nom (avec l'organisation en dessous) + Gestion + menu burger,
// sinon → Se connecter. Sans onMenuNavigate, repli sur l'ancien bouton
// Déconnexion — le burger n'apparaît que pour les comptes connectés.
export function SiteHeaderAccountActions({ user, onGoLogin, onGoGestion, onLogout, onMenuNavigate }) {
  if (!user) {
    return (
      <button className="rc-btn rc-btn-outline site-header-btn" onClick={onGoLogin}>
        Se connecter
      </button>
    );
  }
  return (
    <>
      <div className="site-header-account">
        <span className="site-header-username">
          {user.surname} {user.name}
        </span>
        {user.organization && (
          <span className="site-header-org">{user.organization}</span>
        )}
      </div>
      <button className="rc-btn rc-btn-primary site-header-btn" onClick={onGoGestion}>
        Gestion
      </button>
      {onMenuNavigate ? (
        <BurgerMenu user={user} onNavigate={onMenuNavigate} onLogout={onLogout} />
      ) : (
        <button className="rc-btn rc-btn-outline site-header-btn" onClick={onLogout}>
          Déconnexion
        </button>
      )}
    </>
  );
}

// Header des écrans de gestion : mêmes marque et disposition que les pages
// publiques, avec le titre de l'écran et le menu burger (Mon compte,
// Facturations, Abonnement, Se déconnecter). Les boutons supplémentaires
// éventuels (children) se placent avant le menu. Sans user/onNavigate,
// repli sur l'ancien bouton Déconnexion.
export function GestionHeader({ title, onBack, onHome, onLogout, user, onNavigate, children }) {
  return (
    <SiteHeader onBack={onBack} onLogoClick={onHome} title={title}>
      {children}
      {user && onNavigate ? (
        <BurgerMenu user={user} onNavigate={onNavigate} onLogout={onLogout} />
      ) : (
        <button className="rc-btn rc-btn-outline site-header-btn" onClick={onLogout}>
          Déconnexion
        </button>
      )}
    </SiteHeader>
  );
}

export default SiteHeader;
